import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TrackeritemBreakdownService } from '../../../services/trackeritem.breakdown.service';

/**
 * Progress bar + brief explainer for a Tracker Item's sub-tasks (#65237), shown in the
 * edit-header on every tab -- same placement/visibility pattern as <dependency-header>, so a
 * ticket's sub-task progress is visible without having to open the Breakdown tab. The Breakdown
 * tab itself keeps the Remaining/Burndown charts and the Sub-Tasks table/quick-add.
 */
@Component({
  selector: 'breakdown-header',
  template: require('./breakdown.header.component.html')
})
export class BreakdownHeaderComponent implements OnChanges {
  @Input() trackeritem: any;

  summary: any = null;

  constructor(private breakdownService: TrackeritemBreakdownService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.trackeritem) {
      this.ensureSummary();
    }
  }

  private ensureSummary(): void {
    if (!this.trackeritem?.hasSubitems) {
      this.summary = null;
      return;
    }

    this.breakdownService.ensureChildrenLoaded(this.trackeritem).then(() => {
      this.summary = this.breakdownService.getSummary(this.trackeritem);
    });
  }

  progressBarClass(): string {
    return this.breakdownService.progressBarClass(this.summary);
  }
}
